module.exports = __webpack_public_path__ + "static/img/036官网2版3.f7384d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/036官网2版3.jpg
// module id = rMG7
// module chunks = 0